import React, { useState, useRef } from 'react';

import DismissableModal from '../DismissableModal';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import './PawStatus.css';

const ReOpenDialog = (props) => {
  const [isCommentValid, setIsCommentValid] = useState(false);
  const [comments, setComments] = useState("");
  const modalRef = useRef(null);

  const reOpenDrugGroup = () => {
    if (isCommentValid) {
      props.reOpenDrugGroup(comments);
      modalRef.current.handleClose();
    }
  }

  const handleCommentChange = (e) => {
    setComments(e.target.value);
    setIsCommentValid(e.target.value !== "");
  }

  const { disallowEditing } = props;
  const customFooterContent = (
    <div>
      <Button id='switchdetails-btn-sfr-cancel' variant="outline-dark" onClick={() => modalRef.current.handleClose()}>Cancel</Button>
      <Button
        id='switchdetails-btn-sfr'
        className="left-spacer"
        variant="warning"
        onClick={reOpenDrugGroup}>
        Yes, reopen the drug group
      </Button>
    </div>
  );
  return (
    <DismissableModal
      ref={modalRef}
      customFooterContent={customFooterContent}
      openModalButtonText="Reopen DrugGroup"
      openModalButtonStyle="primary"
      openModalButtonBlock={true}
      openModalButtonDisabled={disallowEditing}
      openModalButtonId='switchdetails-btn-sfr-popup'
      openModalButtonClassName="btn-block"
      title="Reopen Drug Group" >
      <p className="confirmation-text">
        You have selected to <b>Reopen</b> this Drug Group for review.
      </p>
      <p className="text-muted">Once you reopen this drug group, all the drug group with same Source Drug Group and Dynamic Search Group will reopen as well</p>
      <Form.Group>
        <Form.Label>Please enter comments for reviewer</Form.Label>
        <Form.Control
          id='switchdetails-textarea-sfr-comments'
          as="textarea"
          rows="3"
          value={comments}
          onChange={handleCommentChange} />
        {
          !isCommentValid ? <span className="text-danger smaller-feedback">Comments are mandatory!</span> : <span className="text-success smaller-feedback">Looks good!</span>
        }
      </Form.Group>
    </DismissableModal>
  );
}

export default ReOpenDialog;
